"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _decorate = require("@/api/zdyPage/decorate");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'imgStyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      imageList: []
    };
  },
  created: function created() {
    this.initImageList();
  },
  methods: {
    initImageList: function initImageList() {
      // 初始化图片列表
      if (this.datas && this.datas.images) {
        // console.log('初始化图片列表：', this.datas.images)
        this.imageList = this.datas.images.map(function (img) {
          return _objectSpread(_objectSpread({}, img), {}, {
            httpType: 11
          });
        });
      } else {
        // 默认添加一张图片
        this.imageList = [this.getDefaultImage()];
      }

      // 初始化轮播间隔，默认为3秒
      if (this.datas && this.datas.mode === 2 && this.datas.interval === undefined) {
        this.datas.interval = 3;
      }
    },
    getDefaultImage: function getDefaultImage() {
      return {
        imgSrc: '',
        title: '',
        httpType: 11,
        http: ''
      };
    },
    handleModeChange: function handleModeChange(value) {
      // 模式改变时的处理
      console.log('图片模式改变为：', value);
      if (value === 2) {
        // 轮播模式
        if (this.datas.interval === undefined) {
          this.datas.interval = 3; // 设置默认轮播间隔为3秒
        }
      }
    },
    handlePreview: function handlePreview(file) {
      // 预览文件
      console.log('Preview file:', file);
    },
    handleFileChange: function handleFileChange(event, index) {
      var _this = this;
      var file = event.target.files[0];
      if (!file) return;

      // 验证文件格式和大小
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return;
      }

      // 上传文件
      var formData = new FormData();
      formData.append('file', file);
      (0, _decorate.uploadImg)(formData).then(function (res) {
        if (res.code === 200) {
          // 后端返回 { code, data: { pathKey } }，取 pathKey 作为图片路径
          var imgSrc = res.data && res.data.pathKey ? res.data.pathKey : res.data;
          // 更新指定索引的图片信息
          _this.$set(_this.imageList, index, _objectSpread(_objectSpread({}, _this.imageList[index]), {}, {
            imgSrc: imgSrc
          }));
          _this.$message.success('上传成功');
        } else {
          _this.$message.error('上传失败' + res.message);
        }
      }).catch(function (err) {
        _this.$message.error('上传失败:' + err);
        console.log(err);
      });
    },
    handleImageClick: function handleImageClick(index) {
      // 触发文件选择
      var fileInput = this.$refs["fileInput-".concat(index)];
      if (fileInput && fileInput.length > 0) {
        fileInput[0].click();
      }
    },
    handleRemoveImage: function handleRemoveImage(index) {
      // 移除指定索引的图片
      this.$set(this.imageList, index, this.getDefaultImage());
    },
    addImage: function addImage() {
      // 添加新图片
      this.imageList.push(this.getDefaultImage());
    },
    deleteImage: function deleteImage(index) {
      // 删除指定索引的图片
      if (this.imageList.length <= 1) {
        this.$message.warning('至少需要保留一张图片');
        return;
      }
      this.imageList.splice(index, 1);
    }
  },
  watch: {
    imageList: {
      handler: function handler(newVal) {
        if (this.datas) {
          this.datas.images = newVal;
        }
      },
      deep: true
    }
  }
};